import React, { useEffect, useState } from 'react';
import ComboSimple from '../../../../../shared/components/Combos/Simple';

export const SelectorValidadoresAS400 = (props:any) =>{

  let {data, onChange,nullOption} = props;
  let [options, setOptions] = useState<any>(undefined)

  useEffect(()=>{
    if(data)
    {
      setOptions(getOptions())
    }
  },[data])
  
  const getOptions = () =>{
    let dataOption = nullOption == true ? [{ value: null, inputDisplay: '' }] : []
    
    return [...dataOption, ...data.map((d:any)=> { return { value: d, inputDisplay: d.nombre } })]

  }

  useEffect(()=>{
    if(options)
    {
    let defaultSelected = options.filter((f:any)=> f.value.porDefecto===true);
    defaultSelected = defaultSelected.length>0?defaultSelected[0].value : null;
    onChange(defaultSelected);
    }
  },[options])

  return (
    <ComboSimple {...props} options={options} name="selectValidadoresAS400"/>
  )
}